export default "__VITE_PUBLIC_ASSET__3e116f77__"